// ---- Kundenbewertungen: Laden, Anzeigen, Formular, Absenden ----
// Nutzt die eigene NEXUS-App über Shopifys App Proxy. Beide Adressen sind
// relative Shop-URLs (/apps/bewertungen/...), kein CORS nötig — siehe
// snippets/produkt-bewertungen.liquid für die Hintergründe.
(function initProduktBewertungen() {
  var wurzel = document.getElementById('produktBewertungen');
  if (!wurzel) return;
  var handle = wurzel.getAttribute('data-produkt-handle');
  if (!handle) return;

  var uebersicht = document.getElementById('bewertungenUebersicht');
  var schnittZahl = document.getElementById('bewertungenSchnittZahl');
  var schnittSterne = document.getElementById('bewertungenSchnittSterne');
  var schnittAnzahl = document.getElementById('bewertungenSchnittAnzahl');
  var leerHinweis = document.getElementById('bewertungenLeer');
  var liste = document.getElementById('bewertungenListe');
  var tabAnzahlLabel = document.getElementById('produktBewertungAnzahl');

  function sterneHtml(sterne, groesse) {
    var voll = Math.round(sterne);
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += '<svg width="' + groesse + '" height="' + groesse + '" viewBox="0 0 24 24" ' +
        (i <= voll ? 'fill="currentColor" stroke="currentColor"' : 'fill="none" stroke="currentColor"') +
        ' stroke-width="1.6"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    }
    return html;
  }

  function datumFormatieren(isoText) {
    try {
      var d = new Date(isoText);
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' });
    } catch (e) {
      return '';
    }
  }

  function initialen(name) {
    var teile = (name || '').trim().split(/\s+/);
    if (!teile[0]) return '?';
    var erste = teile[0].charAt(0);
    var zweite = teile.length > 1 ? teile[teile.length - 1].charAt(0) : '';
    return (erste + zweite).toUpperCase();
  }

  function leerZustandZeigen() {
    if (uebersicht) uebersicht.hidden = true;
    if (leerHinweis) leerHinweis.hidden = false;
    if (liste) liste.innerHTML = '';
    if (tabAnzahlLabel) tabAnzahlLabel.textContent = '';
  }

  function bewertungenRendern(daten) {
    daten = daten || {};

    // Vorher wurde "daten.anzahl || 0" verwendet — das behandelt jeden
    // falsy-Wert (0, undefined, null, "") gleich, lässt aber unerwartete
    // Formen wie einen String-Wert ("0" statt 0) unbemerkt durchrutschen:
    // "0" (String) ist bei "anzahl === 0" nicht strikt gleich 0 (Zahl) —
    // der Code landet dann im "hat Bewertungen"-Zweig, obwohl gar keine
    // Zahl vorliegt, und zeigt einen unbefüllten Zwischenzustand (der
    // Kasten wird sichtbar, aber schnittZahl bleibt leer). Jetzt wird
    // explizit auf einen echten Zahlentyp geprüft, alles andere gilt als
    // "keine Bewertungen".
    var anzahl = typeof daten.anzahl === 'number' && daten.anzahl > 0 ? daten.anzahl : 0;
    var durchschnitt = typeof daten.durchschnitt === 'number' ? daten.durchschnitt : null;

    if (tabAnzahlLabel) tabAnzahlLabel.textContent = anzahl > 0 ? '(' + anzahl + ')' : '';

    // Bewertungs-Kurzzeile unterm Produkttitel (sections/produkt.liquid):
    // nur einblenden, wenn es echte Daten gibt — sonst bleibt sie
    // unsichtbar und die Seite sieht aus wie ohne Bewertungsfunktion.
    var kurzZeile = document.getElementById('produktSterneZeile');
    var kurzSymbole = document.getElementById('produktSterneSymbole');
    var kurzSchnitt = document.getElementById('produktSterneSchnitt');
    var kurzAnzahl = document.getElementById('produktSterneAnzahl');
    if (kurzZeile) {
      if (anzahl > 0 && typeof daten.durchschnitt === 'number') {
        if (kurzSymbole) kurzSymbole.innerHTML = sterneHtml(daten.durchschnitt, 15);
        if (kurzSchnitt) kurzSchnitt.textContent = daten.durchschnitt.toFixed(1).replace('.', ',');
        if (kurzAnzahl) kurzAnzahl.textContent = '(' + (anzahl === 1 ? '1 Bewertung' : anzahl + ' Bewertungen') + ')';
        kurzZeile.hidden = false;
      } else {
        kurzZeile.hidden = true;
      }
    }

    // Zusätzlich zu anzahl > 0 wird jetzt auch verlangt, dass durchschnitt
    // eine echte Zahl ist — nur eine Anzahl ohne gültigen Durchschnitt
    // reicht nicht, um die Übersicht anzuzeigen, sonst bliebe schnittZahl
    // leer und der Kasten wäre wieder ein leerer Platzhalter.
    if (anzahl === 0 || durchschnitt === null) {
      leerZustandZeigen();
      return;
    }

    if (leerHinweis) leerHinweis.hidden = true;
    if (uebersicht) {
      uebersicht.hidden = false;
      if (schnittZahl) schnittZahl.textContent = durchschnitt.toFixed(1).replace('.', ',');
      if (schnittSterne) schnittSterne.innerHTML = sterneHtml(durchschnitt, 18);
      if (schnittAnzahl) {
        schnittAnzahl.textContent = anzahl === 1 ? '1 Bewertung' : anzahl + ' Bewertungen';
      }
    }

    if (liste) {
      liste.innerHTML = (daten.reviews || []).map(function (r) {
        var name = r.name ? String(r.name) : 'Anonym';
        var text = r.text ? String(r.text) : '';
        // Reiner Text, keine HTML-Ausführung -- textContent statt innerHTML
        // wäre sicherer, hier über einen Hilfs-Escape für die Vorlage.
        var escapen = function (s) {
          var d = document.createElement('div');
          d.textContent = s;
          return d.innerHTML;
        };
        // Abzeichen "Verifizierter Kauf" — erscheint NUR, wenn die App das
        // Feld verifiziert:true zurückmeldet. Die Prüfung selbst findet
        // serverseitig statt: nur dort lässt sich feststellen, ob der
        // Kunde dieses Produkt tatsächlich gekauft hat. Meldet die App
        // nichts, bleibt das Abzeichen einfach weg — nichts sieht kaputt
        // aus. Ein Abzeichen allein aufgrund eines Logins wäre irreführend
        // und in Deutschland abmahnfähig.
        var verifiziertHtml = r.verifiziert === true
          ? '<span class="bewertung-verifiziert" title="Dieser Kunde hat das Produkt nachweislich gekauft">' +
              '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' +
              'Verifizierter Kauf</span>'
          : '';

        return '<div class="bewertung-karte">' +
          '<div class="bewertung-karte-kopf">' +
            '<div class="bewertung-avatar">' + escapen(initialen(name)) + '</div>' +
            '<div class="bewertung-karte-meta">' +
              '<span class="bewertung-name">' + escapen(name) + verifiziertHtml + '</span>' +
              '<span class="bewertung-datum">' + escapen(datumFormatieren(r.datum)) + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="bewertung-karte-sterne">' + sterneHtml(r.sterne || 0, 15) + '</div>' +
          '<p class="bewertung-karte-text">' + escapen(text) + '</p>' +
        '</div>';
      }).join('');
    }
  }

  function bewertungenLaden() {
    fetch('/apps/bewertungen/produkt/' + encodeURIComponent(handle))
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('Antwort nicht ok');
        return antwort.json();
      })
      .then(bewertungenRendern)
      .catch(function () {
        // Aktiv in den "leer"-Zustand zurückfallen statt nur nichts zu tun
        // — vorher blieb bei einem Fehler (App kurzzeitig nicht erreichbar,
        // unerwartete Antwort) einfach der HTML-Ausgangszustand stehen.
        // Das ist unauffällig, solange niemand vorher etwas verändert hat,
        // aber garantiert nichts: ein sauberer, garantierter Leer-Zustand
        // ist hier die sicherere Wahl, kein Fehler sichtbar für den Kunden.
        leerZustandZeigen();
      });
  }

  bewertungenLaden();

  // ---- Formular: öffnen/schließen ----
  var schreibenBtn = document.getElementById('bewertungSchreibenBtn');
  var formularWrap = document.getElementById('bewertungFormularWrap');
  var formular = document.getElementById('bewertungFormular');
  var abbrechenBtn = document.getElementById('bewertungAbbrechenBtn');
  var erfolgBox = document.getElementById('bewertungErfolg');
  var fehlerBox = document.getElementById('bewertungFormularFehler');

  if (schreibenBtn && formularWrap) {
    schreibenBtn.addEventListener('click', function () {
      formularWrap.hidden = false;
      schreibenBtn.hidden = true;
      var nameFeld = document.getElementById('bewertungName');
      if (nameFeld) nameFeld.focus();
    });
  }
  if (abbrechenBtn && formularWrap) {
    abbrechenBtn.addEventListener('click', function () {
      formularWrap.hidden = true;
      if (schreibenBtn) schreibenBtn.hidden = false;
      if (formular) formular.reset();
      sterneZuruecksetzen();
    });
  }

  // ---- Sternauswahl ----
  var sterneWert = document.getElementById('bewertungSterneWert');
  var sterneButtons = document.querySelectorAll('.bewertung-stern-btn');
  function sterneAnzeigen(wert) {
    sterneButtons.forEach(function (btn) {
      var istAktiv = parseInt(btn.getAttribute('data-stern'), 10) <= wert;
      btn.classList.toggle('is-active', istAktiv);
      btn.setAttribute('aria-checked', istAktiv ? 'true' : 'false');
    });
  }
  function sterneZuruecksetzen() {
    if (sterneWert) sterneWert.value = '0';
    sterneAnzeigen(0);
  }
  sterneButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wert = btn.getAttribute('data-stern');
      if (sterneWert) sterneWert.value = wert;
      sterneAnzeigen(parseInt(wert, 10));
    });
    btn.addEventListener('mouseenter', function () {
      sterneAnzeigen(parseInt(btn.getAttribute('data-stern'), 10));
    });
  });
  var sterneGruppe = document.getElementById('bewertungSterneAuswahl');
  if (sterneGruppe) {
    sterneGruppe.addEventListener('mouseleave', function () {
      sterneAnzeigen(sterneWert ? parseInt(sterneWert.value, 10) : 0);
    });
  }

  // ---- Absenden ----
  function fehlerZeigen(text) {
    if (!fehlerBox) return;
    fehlerBox.textContent = text;
    fehlerBox.hidden = false;
  }
  function fehlerVerstecken() {
    if (fehlerBox) fehlerBox.hidden = true;
  }

  if (formular) {
    formular.addEventListener('submit', function (e) {
      e.preventDefault();
      fehlerVerstecken();

      var name = document.getElementById('bewertungName').value.trim();
      var text = document.getElementById('bewertungText').value.trim();
      var sterne = parseInt(sterneWert ? sterneWert.value : '0', 10);
      var website = document.getElementById('bewertungWebsite').value; // Honeypot

      if (!sterne || sterne < 1 || sterne > 5) {
        fehlerZeigen('Bitte wähle eine Sternebewertung von 1 bis 5.');
        return;
      }
      if (!name) {
        fehlerZeigen('Bitte gib deinen Namen an.');
        return;
      }
      if (!text) {
        fehlerZeigen('Bitte schreib ein paar Worte zu deiner Erfahrung.');
        return;
      }

      var absendenBtn = document.getElementById('bewertungAbsendenBtn');
      if (absendenBtn) { absendenBtn.disabled = true; absendenBtn.textContent = 'Wird gesendet …'; }

      // War: kundeId und kundeEmail als rohe Werte aus dem Liquid. Das war
      // ein Fehler — beides sind normale Felder im JSON-Body. Wer die
      // Anfrage direkt abschickt statt übers Formular, könnte dort jede
      // beliebige Kundennummer eintragen und sich so das
      // "Verifiziert"-Abzeichen erschleichen. Die App-Proxy-Signatur
      // beweist nur, dass die Anfrage über Shopify kam, nicht WER sie
      // geschickt hat.
      //
      // Jetzt das signierte Sitzungs-Token aus dem Kundenkonto-System
      // (siehe nexus-konto.js, gleicher Speicherschlüssel). Die App prüft
      // die Signatur selbst und holt die Kundennummer daraus — ohne dem
      // Browser irgendetwas zu glauben.
      var sitzung = '';
      try {
        sitzung = localStorage.getItem('nexus_kunde_token') || '';
      } catch (e) { /* privater Modus: dann eben ohne Kennzeichnung */ }

      fetch('/apps/bewertungen/absenden', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productHandle: handle,
          name: name,
          sterne: sterne,
          text: text,
          website: website,
          sitzung: sitzung
        })
      })
        .then(function (antwort) {
          if (antwort.status === 429) {
            throw new Error('Du hast in letzter Zeit schon einige Bewertungen abgeschickt. Versuch es später erneut.');
          }
          if (antwort.status === 400) {
            return antwort.json().then(function (daten) {
              throw new Error(daten.error || 'Die Angaben konnten nicht gespeichert werden.');
            });
          }
          if (!antwort.ok) {
            throw new Error('Die Bewertung konnte nicht gespeichert werden. Versuch es später erneut.');
          }
          return antwort.json();
        })
        .then(function () {
          if (formular) formular.hidden = true;
          if (erfolgBox) erfolgBox.hidden = false;
          bewertungenLaden();
          // Formular nach kurzer Zeit wieder für eine weitere Bewertung
          // bereitstellen, ohne die Erfolgsmeldung sofort verschwinden zu lassen.
          setTimeout(function () {
            if (formularWrap) formularWrap.hidden = true;
            if (schreibenBtn) schreibenBtn.hidden = false;
            if (formular) { formular.reset(); formular.hidden = false; }
            if (erfolgBox) erfolgBox.hidden = true;
            sterneZuruecksetzen();
          }, 2500);
        })
        .catch(function (err) {
          fehlerZeigen(err.message || 'Etwas ist schiefgelaufen. Versuch es erneut.');
        })
        .finally(function () {
          if (absendenBtn) { absendenBtn.disabled = false; absendenBtn.textContent = 'Bewertung absenden'; }
        });
    });
  }
})();

// Klick auf die Bewertungs-Kurzzeile unterm Titel: Bewertungs-Tab
// aktivieren und zur Tab-Sektion scrollen.
(function sterneZeileVerdrahten() {
  var zeile = document.getElementById('produktSterneZeile');
  if (!zeile) return;
  zeile.addEventListener('click', function () {
    var tabKnopf = document.querySelector('.product-tab-btn[data-tab="bewertungen"]');
    if (tabKnopf) tabKnopf.click();
    var sektion = document.querySelector('.product-tabs-section');
    if (sektion) sektion.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
